(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('DocumentationController', DocumentationController).value('duScrollOffset', 130);


        DocumentationController.$inject = [ '$timeout', '$state', '$rootScope', '$scope', '$window', '$document'];

    function DocumentationController ($timeout, $state, $rootScope, $scope, $window, $document) {
		var vm = this;
		vm.triggerSlider = triggerSlider;
		vm.itemClick = itemClick;

		var viewport = function () {
        var e = window, a = 'inner';
        if (!('innerWidth' in window)) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return {
            width: e[a + 'Width'],
            height: e[a + 'Height']
        };
    };

		  // function that adds information in a scope of the height and width of the page
    $scope.getWindowDimensions = function () {
        return {
            'h': viewport().height,
            'w': viewport().width
        };
    };
    // Detect when window is resized and set some variables
    $scope.$watch($scope.getWindowDimensions, function (newValue, oldValue) {
        $scope.windowHeight = newValue.h;
        $scope.windowWidth = newValue.w;
        if (newValue.w >= 992) {
			 angular.element('#docs-sidebar').addClass('sidebar-visible').removeClass('sidebar-hidden');
			 angular.element('.sidebar-toggler').removeClass('toggler-show');
        }
        if (newValue.w < 992 && newValue.w > 768) {
			 angular.element('#docs-sidebar').addClass('sidebar-visible').removeClass('sidebar-hidden');
			 angular.element('.sidebar-toggler').removeClass('toggler-show');
        }
        if (newValue.w <= 768) {
			angular.element('#docs-sidebar').addClass('sidebar-hidden').removeClass('sidebar-visible');
			angular.element('.sidebar-toggler').addClass('toggler-show').addClass('toggler-hidden');
        }
    }, true);

	 function triggerSlider() {
		if ( angular.element('#docs-sidebar').hasClass('sidebar-visible') ) {

			  angular.element("#docs-sidebar").removeClass('sidebar-visible').addClass('sidebar-hidden');
			  angular.element('.sidebar-toggler').removeClass('toggler-visible').addClass('toggler-hidden');

		} else {

			  angular.element("#docs-sidebar").removeClass('sidebar-hidden').addClass('sidebar-visible');
			  angular.element('.sidebar-toggler').removeClass('toggler-hidden').addClass('toggler-visible');

		}
	 }

	 function itemClick() {
		if ( $scope.windowWidth <= 768) {
			  angular.element("#docs-sidebar").removeClass('sidebar-visible').addClass('sidebar-hidden');
			  angular.element('.sidebar-toggler').removeClass('toggler-visible').addClass('toggler-hidden');

		}
	 }

    }
})();
